export default "__VITE_ASSET__5e84aa92__"